import React from 'react';
import Info from '../../info';

export default function ViewAllGroupRightBottomPanel() {
  return (
    <Info
      title={APP.LANGUAGE.ViewGroup.Title}
      subtitle={APP.LANGUAGE.ViewGroup.InfoPartOne}
      paragraphs={[APP.LANGUAGE.ViewGroup.InfoPartTwo, APP.LANGUAGE.ViewGroup.InfoPartThree]}
      moreInfoLink={APP.EXTERNAL_LINKS.ViewGroup.MoreInfo}
    />
  );
}
